import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { usePageActionsNode, usePageIdentityNode } from './page-identity';

// Page chrome lives in the shell topbar, not the page body (matching the
// platform app's header): the title renders as a FormantKit `.fk-identity`
// in Z2 at header-scale type, and `actions` portal into Z3a next to the
// global utils. This component renders nothing in-page.
export function PageHeader({ title, actions }: { title?: ReactNode; actions?: ReactNode }) {
  const identityNode = usePageIdentityNode();
  const actionsNode = usePageActionsNode();
  return (
    <>
      {identityNode && title
        ? createPortal(
            <div className="fk-identity">
              <h1
                className="fk-identity__name"
                style={{ margin: 0, fontSize: 'var(--fs-h2)', lineHeight: 1.2 }}
              >
                {title}
              </h1>
            </div>,
            identityNode,
          )
        : null}
      {actionsNode && actions ? createPortal(actions, actionsNode) : null}
    </>
  );
}
